import getClasses from "utils/getClasses";
import styles from "./SessionTypeColorBadge.module.scss";
import { useMemo } from "react";
import SESSION_TYPE_COLORS from "components/Dashboard/utility/constants/session-type-colors";

interface SessionTypeColorBadgeProps {
  colorId?: string;
}

const SessionTypeColorBadge = ({ colorId }: SessionTypeColorBadgeProps) => {
  const color = useMemo(
    () =>
      SESSION_TYPE_COLORS.find((color) => color.id === colorId) ??
      SESSION_TYPE_COLORS[0],
    [colorId],
  );
  return (
    <div
      className={getClasses(
        styles["color"],
        color.id === "neutral-beige" && styles["color--with-border"],
      )}
      style={{ backgroundColor: color.value }}
    />
  );
};

export default SessionTypeColorBadge;
